import { Component } from '@angular/core';

@Component({
    selector: 'ngx-auth',
    template: `
    <ngx-card-layout>
      <router-outlet></router-outlet>
    </ngx-card-layout>
  `,
    styleUrls: ['./auth.component.scss'],
    standalone: false
})
export class AuthComponent {}
